module.exports = __webpack_public_path__ + "img/2025-06-11a_7.1cf6095b.jpg";